import { useTranslation } from '@/i18n/hook';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50 font-sans flex flex-col">
      <Navbar />
      <main className="flex-1 flex flex-col items-center justify-center text-center px-4 pt-16">
        <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-foreground-50 select-none pointer-events-none z-0">
          404
        </h1>
        <div className="relative z-10">
          <h2 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-900">
            {t('notFound.title')}
          </h2>
          <p className="mt-2 text-base text-foreground-500">{location.pathname}</p>
          <p className="mt-4 text-lg md:text-xl text-foreground-600">
            {t('notFound.subtitle')}
          </p>
          <Link
            to="/"
            className="inline-flex items-center mt-6 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors"
          >
            {t('notFound.back')}
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}